import { LocalStorageKeys } from "src/app/core/constants/constants";

export const environment = {
  production: true,

  // This points to web agregator (server)
  serverURL: 'https://server.xoopah.com',
  //serverURL: 'https://xpserverdev.azurewebsites.net/',
  //serverURL: 'https://server.xoopah.com/',

  //AdminAppURL - redirect an admin user back to admin app if the admin is impersonating a user
  adminAppURL: 'https://adminapp.xoopah.com',
  //adminAppURL: 'https://xpadminappdev.azurewebsites.net/',
  //adminAppURL: 'https://adminapp.xoopah.com/',

  // app url used to point redirection on deployed app isntance
  clientAppURL: 'https://app.xoopah.com',
  //clientAppURL: 'https://xpappdev.azurewebsites.net/',
  //clientAppURL: 'https://demoapp.xoopah.com/',

  //Old Xoopah Client App URL

  oldXoopahClientAppURL: "https://orders.xoopah.com/includes/users/redirection.php?SK=",
  //oldXoopahClientAppURL: "https://ordersdev.xoopah.com/includes/users/redirection.php?SK=",
  //oldXoopahClientAppURL: "https://orders.xoopah.com/includes/users/redirection.php?SK=",

  // used for google OAuth. this doesnt require any variable replacement as it is same for all the instances
  googleClientId: '1034934855375-0qk4jjc1ha10279bltrp3fcnc3ujid17.apps.googleusercontent.com',

  //this points to alerts microservice used for singalR hub
  notificationServerURL: 'https://alert.xoopah.com/notifications',
  //notificationServerURL: 'https://xpalertdev.azurewebsites.net/notifications',
  //notificationServerURL: 'https://alert.xoopah.com/notifications',


  xoopahPublicKey:
    '-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwp6c26xjdYf/oO1zQ1PSiwwW3dtcmKKQT6S8S/dzstRig/2nPl2qvywnljaexTgUBHZWhhoPOSIiqVHrBbs6Is0N3dNONkh41KZJyyGhCCc/iv7qNB6VIcTGjbX9PLSkRwkF3UBYznrkdF979T5HSqnchjrp4+AtIRNIvsI1kkRS0EIS6ATaBrQCeLlAhWzQePzwGmqIhzNxcbH/BukgYKu1ruyI5Jx0WTlNM9km1PK16QBeiJgZZZaQtRsMtNMYjUvFmHF4ZmI5xju+2mrdfl5otpG1mN+82koYhGuJPeGYRxoLYZ+6gn11vu6BhV00aLD1m/gejsz3aDkWNlsQVwIDAQAB\n-----END PUBLIC KEY-----',

  // Sentry configuration for Xoopah 
  sentryConfig: {

    apiKey: 'https://6c7e07697db248e4b46beb137507cedb@o1133429.ingest.us.sentry.io/6179970',
    loggingURL: 'https://app.xoopah.com',
    isEnableLogging: 'false'

    // DEV
    // apiKey: 'https://6010bb80769b4f319a9385c106f973de@o1270217.ingest.sentry.io/6460767',
    // loggingURL: 'https://xpappdev.azurewebsites.net/',
    // isEnableLogging: 'false'

    // Manual
    // apiKey: 'https://6c7e07697db248e4b46beb137507cedb@o1133429.ingest.sentry.io/6179970',
    // loggingURL: 'https://demoapp.xoopah.com/',
    // isEnableLogging: 'false'

  },


  // key for TinyMC
  tinymceApiKey: 'ze8mhkao01cq0f8fnshku8sihl4j1dvgqlrw18ozloiq7q73',
  facebookClientId: '936615754482001',
  facebookAPIVersion: 'v23.0',
  shopifyClientId: '707949f060dc0d6f912e7284cd2a4989',
  shopifyScopes: 'read_products',

  //key for stripe
  stripePublishableKey: 'pk_live_51MuY0zA2CRVl9lPYVyWlw4ZDA7pdsfRgXplSL6ric1NZ2EXKzqfzCilSbC2nZsjzK0ZATRkGPpEiN44DjxIQcb0600OczxC5Yz',

  //key for google map
  googleMapKey: 'AIzaSyCpHAY0W09-DxADR2LRtrlqM8i1SNz8WwE',

  //key for Google Fonts catalog discovery
  googleFontsApiKey: 'AIzaSyCFi9TpN-US3-sDjdVqj6sktjGoS9AaCKc',

  //base URL for the Iconify icon catalog API (public host; swap for a self-hosted instance if needed)
  iconifyApiBaseUrl: 'https://api.iconify.design',


  // tinymceApiKey: '8vargl7nba2eocj23ok3tyq799l9rfjlj01091w25f5wo22y',
  // facebookClientId: '1406356480162186',


  // tinymceApiKey: '8vargl7nba2eocj23ok3tyq799l9rfjlj01091w25f5wo22y',
  // facebookClientId: '1406356480162186',

  // tinymceApiKey: '8vargl7nba2eocj23ok3tyq799l9rfjlj01091w25f5wo22y',
  // facebookClientId: '936615754482001',
  recaptchaSiteKey: '6LfDoRAsAAAAAJKcsWP_Xa2dqBAMsvQw8ExHbPPj',
  version: '2.0.0',

  // Pexels API
  pexelsAPIKey: 'nAa6GM2EH3KNIrwF66NAKI3NUDb6PTHULEUM2nrucoCOTZY49MXCk730',
  pexelsPhotosBaseUrl: 'https://api.pexels.com/v1',
  pexelsVideosBaseUrl: 'https://api.pexels.com/videos',

  // Tawk.to Widget key
  tawkToWidgetKey: '69c4f4ad46a6c41c341ab6db/1jkklni2n',
  //  test comment for redeploy
};
